var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailConfirmed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-59",
    d: "M97.26,429.45c86.06,45,225.6,45,311.66,0s86.06-117.86,0-162.82-225.6-45-311.66,0S11.19,384.5,97.26,429.45Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-59"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-59",
    cx: 354.66,
    cy: 365.03,
    rx: 40.89,
    ry: 23.61,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111,385.28l-2.72-1.57a8.84,8.84,0,0,1-4-6.93V138.29a8.85,8.85,0,0,1,4-6.94l110-63.5a8.83,8.83,0,0,1,8,0L229,69.42a8.85,8.85,0,0,1,4,6.93v238.5a8.85,8.85,0,0,1-4,6.93l-110,63.5A8.83,8.83,0,0,1,111,385.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.37,143l-14.92-8.61a8.25,8.25,0,0,0-1.17,3.95V376.78a8.84,8.84,0,0,0,4,6.93l2.72,1.57a8.83,8.83,0,0,0,8,0l1.36-.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,144.48V383c0,2.56,1.79,3.59,4,2.31l110-63.5a8.85,8.85,0,0,0,4-6.93V76.35c0-2.55-1.79-3.58-4-2.31L119,137.55A8.82,8.82,0,0,0,115,144.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.8,159.56l100-57.75c1.89-1.09,3.43-.2,3.43,2V294.06a7.58,7.58,0,0,1-3.43,5.94l-100,57.74c-1.9,1.1-3.43.21-3.43-2V165.5A7.55,7.55,0,0,1,123.8,159.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.36,174.55c11.21-6.47,20.3-1.22,20.3,11.72s-9.09,28.7-20.3,35.17-20.3,1.23-20.3-11.72S163.15,181,174.36,174.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.37,243.8c0-21.27-14.93-30.72-33.35-20.08l-11.52,6.65c-18.42,10.63-33.35,36.5-33.35,57.77v5.73l78.22-45.14Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M174,112c1.48-.86,2.68-.16,2.68,1.55a5.91,5.91,0,0,1-2.68,4.64c-1.48.86-2.68.16-2.68-1.55A5.91,5.91,0,0,1,174,112Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.26,125.38c5.45-3,15.17-8.79,20.54-11.95.91-.54,1.65-.17,1.65.82a3.55,3.55,0,0,1-1.66,2.76l-20.57,11.88c-.92.53-1.66.16-1.66-.84A3.41,3.41,0,0,1,166.26,125.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.06,128.39c.83-.48,1.51-.09,1.51.87a3.34,3.34,0,0,1-1.51,2.61c-.83.48-1.51.09-1.51-.87A3.34,3.34,0,0,1,161.06,128.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,335c3-1.71,5.37-.32,5.37,3.1a11.84,11.84,0,0,1-5.37,9.29c-3,1.71-5.36.32-5.36-3.1A11.86,11.86,0,0,1,174,335Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--check-mark--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.21,268.14l-12.06-7h0l-.13-.07v0c-6-3.38-14.22-2.89-23.33,2.38-8.52,4.91-16.3,13.1-22.16,22.59-6.77,10.92-11,23.57-11,34.9,0,10.57,3.7,18,9.68,21.47h0l0,0,12.25,7c6.05,3.86,14.58,3.51,24.06-1.95C260.83,337,275.7,311.21,275.7,290,275.7,279,271.66,271.41,265.21,268.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.2,349.35l-12-6.86h0c-6-3.47-9.68-10.9-9.68-21.47,0-11.34,4.26-24,11-34.9l12.82,7.39c-6.78,10.93-11,23.55-11,34.87C209.29,338.47,212.68,345.7,218.2,349.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,268c-5.92-2.87-13.81-2.14-22.47,2.85S226.19,284,220.32,293.49L207.5,286.1c5.86-9.49,13.64-17.68,22.16-22.59,9.1-5.26,17.33-5.76,23.33-2.38v0l.13.07h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.79 281.5 255.19 278.84 237.18 321.29 240.25 323.06 259.79 281.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.65 311.81 229.05 309.16 224.11 319.61 228.71 322.26 233.65 311.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.43 335.51 228.71 322.26 233.65 311.81 240.25 323.06 259.79 281.5 267.03 288.56 241.43 335.51",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.11 319.61 228.71 322.26 241.43 335.51 236.84 332.88 224.11 319.61",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359,163.92h0a19.64,19.64,0,0,0,19.64-19.64v-1.16A16.64,16.64,0,0,0,362,126.47h-6a16.65,16.65,0,0,0-16.65,16.65v1.16A19.64,19.64,0,0,0,359,163.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.74,358.19a53,53,0,0,1-7.5,6.52,3.22,3.22,0,0,0-1,1.07c-.35.74-.9,2.56,2.45,3.73a12.46,12.46,0,0,0,10.34-1c2.76-1.72,2.88-5.3,5.48-7.35,1.92-1.51,4.32-1.9,5.88-3.88,1.08-1.38.8-3.21.23-5.48-.61-2.48-.9-4.35-1.72-4.16l.14,1.14c-1,1.63-6.33,2.11-8.69,1C344.31,349.76,340.23,356.56,338.74,358.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.41,360.5h0c.8-.73,1.58-1.49,2.33-2.31a64.08,64.08,0,0,0,4.33-6.38,7.18,7.18,0,0,0,1.21-4.56c-.19-1.72-.66-6.11-.66-6.11l8.4-.6,1,8.24h0c.2,1.87-1.34,3.53-4.08,5.89s-6.2,7.85-8.68,9.23-4.24,1.33-5.3.62S333.75,363.23,336.41,360.5Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.69,358.94v-1.27c-.49,1.49-2.8,7.86-6.31,11.06-2.78,2.54-6.58,5.47-7.55,8.31s5.29,3.93,7.89,3.47c3-.53,6.94-2.25,9.07-4.86,1.49-1.84,2.45-4,3.52-5.47s3.53-3.06,4.11-4.74c.32-.92-.06-2.93-.51-4.63s-.85-3.28-1.38-3.14v1a7,7,0,0,1-4.42,1.49C373.82,360.18,370.68,359.92,370.69,358.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.86,371c.86-.77,1.73-1.52,2.52-2.24,2.45-2.23,4.32-6,5.39-8.6a12.17,12.17,0,0,0,.93-4.65v-5h8.83v8.2h0v.22l0,0c-.42,1.84-4.48,6.72-6.78,9.9-1.54,2.13-4.47,4.85-8,5.32C361.4,374.53,359.7,373.48,361.86,371Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.77,221.68c6.85,14.95-.25,67.63-.25,67.63.21,2.43,3,7.21,4,17.89,1.22,12.62-1.92,44.3-1.92,44.3a9.55,9.55,0,0,1-8.93.36s-8.41-47.73-10-60.27c-1.38-10.95-4-36.69-4-36.69l-6.88,36.92a51.85,51.85,0,0,1,2.69,10.68c.71,7.39.18,41.52.18,41.52s-3,2.3-8.81,1.45c0,0-10-46.74-10.79-55.62-.46-5.3,5.58-70.36,5.58-70.36Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.77,221.68c6.85,14.95-.25,67.63-.25,67.63.21,2.43,3,7.21,4,17.89,1.22,12.62-1.92,44.3-1.92,44.3a9.55,9.55,0,0,1-8.93.36s-8.41-47.73-10-60.27c-1.38-10.95-4-36.69-4-36.69l-6.88,36.92a51.85,51.85,0,0,1,2.69,10.68c.71,7.39.18,41.52.18,41.52s-3,2.3-8.81,1.45c0,0-10-46.74-10.79-55.62-.46-5.3,5.58-70.36,5.58-70.36Z",
    style: {
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.66,254.9l-2.22-12.23s-9.41-1.95-13.67-6c0,0,4.47,5.57,11.12,7.39l2.5,10.69-3.93,33.4Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.93,215.18c-.07-1-1.91-11.45-3.17-17.31l-12.31,3.77,2.19,10.78L386,220.74C389.26,220.1,389,216.16,388.93,215.18Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.39 193.1 323.57 203.77 332.63 211.53 340.92 198.38 329.39 193.1",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.23,169.33c-5.77.06-12.13,2.15-14.32,6.68s-8.24,17-8.24,17,5.39,7.32,13.48,6.79Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.23,169.33c-5.77.06-12.13,2.15-14.32,6.68s-8.24,17-8.24,17,5.39,7.32,13.48,6.79Z",
    style: {
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.17,169.53l4.81.2c5.22,1.25,7.11,4.84,9.3,9.47a15.08,15.08,0,0,1,.42,11.32l-6.12,17.7s2.86,6.92,6.19,13.46c-15.35,8.57-34.52,4.06-39.14-2.19-.19-1.33.07-7.3-.3-14.1-.39-7.26-1.39-15.45-.25-19.93,2.12-8.32,6.08-16.13,14-16.13Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,169.73c5.23.74,12.93,1.79,15.58,14.24,2.69,12.62,3.2,15.63,3.2,15.63s-4.58,4.57-13.27,4.53C373.49,204.13,365.83,179.35,368,169.73Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,169.73c5.23.74,12.93,1.79,15.58,14.24,2.69,12.62,3.2,15.63,3.2,15.63s-4.58,4.57-13.27,4.53C373.49,204.13,365.83,179.35,368,169.73Z",
    style: {
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.26,203.36c-1-3.31-2-7.09-2.95-11.15a81.74,81.74,0,0,0,1.55,15.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.76,134.41c-2.07,1.23-4.63,6.45-4.38,17.39.21,9.27,3.22,11.56,4.73,12.22s4.42.26,7.25-.21v5.57s-3.91,4.54-3.67,7.09,5.65,3.16,9.31.66a23.72,23.72,0,0,0,6-6.28V157.39s1.91,2.55,5,.48,3.24-7.21,1.43-9.06-5.74-1.26-6.46,1.29c0,0-4.52.17-10.53-3.13A16.91,16.91,0,0,1,345.76,134.41Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.73,149.47a1.17,1.17,0,1,0,1.23-1.15A1.19,1.19,0,0,0,351.73,149.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.42,157.33l-2.71.87a1.4,1.4,0,0,0,1.76,1A1.5,1.5,0,0,0,351.42,157.33Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.17,145.89l2.36-1.63a1.38,1.38,0,0,0-2-.41A1.51,1.51,0,0,0,342.17,145.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.71,148.63a1.17,1.17,0,1,0,1.23-1.16A1.21,1.21,0,0,0,342.71,148.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.21 147.96 348.03 154.98 344.34 153.84 348.21 147.96",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.36,163.81c3-.39,9.11-2.15,10.07-4.58a6.29,6.29,0,0,1-2.15,3.1c-1.83,1.57-7.92,3.34-7.92,3.34Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.55 192.45 338.4 201.36 348.4 243.38 316.21 234.03 304.55 192.45",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.31,220.25c-.31.86-2.17,3.24-6.11,3.05l-.48-1.74Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.88,221.56c.15,1.12,2.45,3.2,6.34,4.49,4.43,1.48,11.22.7,11.22.7l-.61-2.09Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.46,198.53s-.12-.58-.28-1.29,1.84-.75,4.44-.07l5,1.29c2.6.68,4.84,1.81,5,2.52l.28,1.29Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.12,193.66c-.1-.45.7-.56,1.79-.26l2,.54s-.59-2.79,3.79-1.81,5.34,4.14,5.34,4.14l2.11.6c1.17.33,2.22,1,2.36,1.41l.25.8-17.44-4.59S312.21,194.1,312.12,193.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.52,195.05c1.6.39,2.26.6,2.5,1.7.27,1.26.38,2.18.38,2.18l7.72,2s-.37-1.59-.49-2.21.14-1,1.37-.67l.1-.49L314,194.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.25,198.65s-.12-.58-.28-1.29,1.84-.74,4.44-.07l5,1.3c2.6.67,4.84,1.8,5,2.51l.28,1.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,220.74l-10.37-8.32s-22.92,4.08-25.62,4.29a7.07,7.07,0,0,1-6.71-4.33c-1-2.65-2.83-2.32-2.83-2.32s.79,3.35,1,4.42-6.2,2-9.78.74-8.77.55-5.56,5.42,9.46,5.44,13.79,5.44a46.33,46.33,0,0,0,5.43-.36c1.4-.18,2.8-.32,4.21-.42C358.49,224.66,382,222,386,220.74Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,204.73l1.5,5.36c.29,1,4.22,2.9,6.71,3.59s5.21,1.49,4,5c-1.08,3.21-5.18,3.94-7.26,3.85s-4.94-2.08-6.06-5.29c-1.44-4.1-.67-8.48-1.24-10.87S306.75,203.3,308,204.73Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.14,185.46h0A11.13,11.13,0,0,1,365,174.33V158.7h0a11.14,11.14,0,0,1,11.13,11.13Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailConfirmed);
export default __webpack_public_path__ + "static/media/email-confirmed.b5ea478f17d4aec701ff4871eb33814e.svg";
export { ForwardRef as ReactComponent };